import React from 'react'
import { Box, Button, Typography } from '@material-ui/core'
import { TeacherImpersonationInfo } from '../api'

interface Props {
    impersonation: TeacherImpersonationInfo
    onReturnToExaminer: () => void
}

export default function TeacherImpersonationBanner({ impersonation, onReturnToExaminer }: Props) {
    return (
        <Box
            style={{
                backgroundColor: '#fff3e0',
                padding: '12px 16px',
                marginBottom: 16,
                border: '1px solid #ffb74d',
                borderRadius: 4,
            }}
        >
            <Typography variant="body2" style={{ color: '#e65100', fontWeight: 500 }}>
                You are viewing as teacher <strong>{impersonation.teacherName}</strong> ({impersonation.teacherSchoolCode}).
                {' '}Logged in from examiner profile: <strong>{impersonation.examinerUsername}</strong>.
            </Typography>
            <Button
                size="small"
                color="primary"
                variant="outlined"
                style={{ marginTop: 8 }}
                onClick={onReturnToExaminer}
            >
                Return to my profile
            </Button>
        </Box>
    )
}
